import { DatepickerVariables } from '../../../teams/components/Datepicker/datepickerVariables';

export const datepickerCalendarCellButtonVariables = (siteVars: any): Partial<DatepickerVariables> => {
  return {
    calendarCellSelectedColor: siteVars.colors.white,
  };
};
